export default __webpack_public_path__ + "static/media/600.797986d5.png";